export const KAIROS_SERIES_NON_IMAGE_THUMBNAIL_GUARD = 'KAIROS_SERIES_NON_IMAGE_THUMBNAIL_GUARD';

const NON_IMAGE_MODALITIES = new Set(['SR', 'PR', 'KO', 'SEG', 'RTSTRUCT', 'RTPLAN', 'RTDOSE', 'DOC', 'PDF']);

export const isRenderableSeriesThumbnail = (series = {}) => {
  const modality = String(series.modality || '').trim().toUpperCase();
  if (NON_IMAGE_MODALITIES.has(modality)) return false;
  const frames = parseInt(series.displayFrameCount || series.numInstances, 10);
  return Number.isFinite(frames) ? frames > 0 : true;
};
